import { render, staticRenderFns } from "./SupportComponent.vue?vue&type=template&id=24c7cc8a&scoped=true&"
import script from "./SupportComponent.vue?vue&type=script&lang=js&"
export * from "./SupportComponent.vue?vue&type=script&lang=js&"
import style0 from "./css/common.css?vue&type=style&index=0&lang=css&"
import style1 from "./SupportComponent.vue?vue&type=style&index=1&id=24c7cc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c7cc8a",
  null
  
)

export default component.exports